var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_row flex_align_center"},[_c('img',{attrs:{"src":require(`@/assets/images/common/checkbox${
        _vm.item.status == false ? 1 : 11
      }.png`),"alt":""},on:{"click":function($event){_vm.item.status = !_vm.item.status}}}),_c('div',{staticClass:"label",on:{"click":function($event){_vm.item.status = !_vm.item.status}}},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }